<template>
  <div id="app">
    <div class="nav_father">
      <div class="my_nav">
        <img @click="navto('/')" src="../../static/img/logo.png" />
        <ul class="nav navbar-nav nav_ul" id="ul_header">
          <li class="nav_li nav_home">
            <a @click="navto('/')">首&emsp;&emsp;页</a>
          </li>
          <li class="nav_li nav_brand">
            <a @click="showDownNav('Brand')">关于集壹</a>
          </li>
          <li class="nav_li nav_product">
            <a @click="showDownNav('Products')">产品展示</a>
          </li>
          <li class="nav_li nav_download">
            <a @click="showDownNav('Download')">咨询&下载</a>
          </li>
          <li class="nav_li nav_callus">
            <a @click="navto('/CallUs')">联系我们</a>
          </li>
        </ul>
      </div>
      <div class="nav_down" v-show="downnavshow">
        <div class="nav_down_brand" v-show="brandshow">
          <div class="nav_down_img" @click="scrollNavto('/Brand', 'brand')">
            <img src="../../static/img/关于-企业简介.png" />
            <p>企业简介</p>
          </div>
          <div
            class="nav_down_img"
            @click="scrollNavto('/Brand', 'brand_info')"
          >
            <img src="../../static/img/关于-品牌文化.png" />
            <p>品牌文化</p>
          </div>
        </div>
        <div class="nav_down_product" v-show="productshow">
          <div
            class="nav_down_img"
            @click="scrollNavto('/Products', 'bathroom')"
          >
            <img src="../../static/img/产品-浴室柜.png" />
            <p>卫浴洁具系列</p>
          </div>
          <div class="nav_down_img" @click="scrollNavto('/Products', 'valve')">
            <img src="../../static/img/产品-阀门管件.png" />
            <p>阀门管道系列</p>
          </div>
          <div class="nav_down_img" @click="scrollNavto('/Products', 'water')">
            <img src="../../static/img/产品-水泵.png" />
            <p>水泵机电系列</p>
          </div>
          <div class="nav_down_img" @click="scrollNavto('/Products', 'hvac')">
            <img src="../../static/img/产品-暖通.png" />
            <p>暖通流控系列</p>
          </div>
        </div>
        <div class="nav_down_video" v-show="videoshow">
          <div class="nav_down_img" @click="scrollNavto('/Download', 'video')">
            <img src="../../static/img/资讯-视频.png" />
            <p>视频中心</p>
          </div>
          <div
            class="nav_down_img"
            @click="scrollNavto('/Download', 'download')"
          >
            <img src="../../static/img/资讯-下载.png" />
            <p>下载中心</p>
          </div>
          <div class="nav_down_img" @click="scrollNavto('/Download', 'news')">
            <img src="../../static/img/资讯-新闻.png" />
            <p>新闻中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="phone_nav">
      <div class="phone_my_nav">
        <img
          class="phone_logo"
          src="../../static/img/logo.png"
          @click="navto('/')"
        />
        <div class="phone_mune_div">
          <img
            v-show="!isOpenSlider"
            class="phone_mune_logo"
            src="../../static/img/汉堡栏.png"
            @click="openSilder()"
          />
          <img
            v-show="isOpenSlider"
            class="phone_mune_logo"
            src="../../static/img/nav_close.png"
            @click="openSilder()"
          />
        </div>
      </div>

      <div
        class="w3-sidebar w3-bar-block w3-animate-right"
        style="display: none"
        id="mySidebar"
      >
        <div class="siderbar_close" @click="closeSilder()">
          <p></p>
        </div>
        <div class="siderbar_div">
          <p class="w3-bar-item w3-button w3-item1" @click="navto('/')">
            首 页
          </p>
          <button
            class="w3-button w3-block w3-left-align w3-item1"
            @click="myAboutFunc()"
          >
            关于集壹 <i class="fa fa-caret-down"></i>
          </button>
          <div id="aboutAcc" class="w3-hide w3-white">
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Brand', 'brand')"
              >企业简介</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Brand', 'brand_info')"
              >品牌文化</a
            >
          </div>
          <button
            class="w3-button w3-block w3-left-align w3-item1"
            @click="myProductFunc()"
          >
            产品展示 <i class="fa fa-caret-down"></i>
          </button>
          <div id="productAcc" class="w3-hide w3-white">
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Products', 'bathroom')"
              >卫浴洁具系列</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Products', 'valve')"
              >阀门管道系列</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Products', 'water')"
              >水泵机电系列</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Products', 'hvac')"
              >暖通流控系列</a
            >
          </div>
          <button
            class="w3-button w3-block w3-left-align w3-item1"
            @click="myVideoFunc()"
          >
            资讯&下载 <i class="fa fa-caret-down"></i>
          </button>
          <div id="videoAcc" class="w3-hide w3-white">
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Download', 'video')"
              >视频中心</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Download', 'download')"
              >下载中心</a
            >
            <a
              class="w3-bar-item w3-button w3-item2"
              @click="scrollNavto('/Download', 'news')"
              >新闻中心</a
            >
          </div>

          <a class="w3-bar-item w3-button w3-item1" @click="navto('/CallUs')"
            >联系我们</a
          >
        </div>
      </div>
    </div>
    <!-- <div class="container">
      <nav class="navbar navbar-default navbar-fixed-top">
        <div class="container my_navbar_container">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="#"
              ><img src="../../static/img/logo.png"
            /></a>
          </div>
          <div id="navbar" class="navbar-collapse collapse">
            <ul class="nav navbar-nav nav_ul" id="ul_header">
              <li class="nav_li">
                <a @click="navto('/')">首&emsp;&emsp;页</a>
              </li>
              <li class="nav_li">
                <a @click="navto('/Brand')">关于集壹</a>
              </li>
              <li class="nav_li">
                <a @click="navto('/Products')">产品展示</a>
              </li>
              <li class="nav_li">
                <a @click="navto('/Download')">咨询&下载</a>
              </li>
              <li class="nav_li"><a @click="navto('/CallUs')">联系我们</a></li>
            </ul>
          </div>
        </div>
      </nav>
    </div> -->
    <!-- <HomeBanner></HomeBanner> -->
    <keep-alive>
      <router-view :key="$route.fullpath"></router-view>
    </keep-alive>
    <div class="foot">
      <div class="container" style="width: 90%">
        <div class="row footgone" style="padding: 3rem 0">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div>
              <div class="row">
                <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                  <div class="Medium_title">关于集壹</div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Brand', 'brand')"
                  >
                    企业简介
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Brand', 'brand_info')"
                  >
                    品牌文化
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Brand', 'honor')"
                  >
                    荣誉资质
                  </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                  <div class="Medium_title">产品展示</div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Products', 'bathroom')"
                  >
                    卫浴洁具系列
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Products', 'valve')"
                  >
                    阀门管道系列
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Products', 'water')"
                  >
                    水泵机电系列
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Products', 'hvac')"
                  >
                    暖通流控系列
                  </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                  <div class="Medium_title">咨询&下载</div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Download', 'video')"
                  >
                    视频中心
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Download', 'download')"
                  >
                    下载中心
                  </div>
                  <div
                    class="Medium MediumClick"
                    @click="scrollNavto('/Download', 'news')"
                  >
                    新闻中心
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
            <div class="Medium_title">友情链接</div>
            <div class="Medium MediumClick" @click="openLink(jumpList[1].url)">
              {{ jumpList[1].title }}
            </div>
            <div class="Medium MediumClick" @click="openLink(jumpList[0].url)">
              {{ jumpList[0].title }}
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="Medium_title">联系我们</div>
            <div class="Medium">地址：{{ List[0].address }}</div>
            <div class="Medium">邮箱：{{ List[0].email }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <!-- <div class="Medium foot-phone">{{ List[0].phone }}</div>
            <div class="Medium foot-phone">{{ List[0].tel }}</div> -->
            <div class="foot_phone_div">
              <img src="../../static/img/phonebg.png" />
              <div class="Medium foot-phone">
                <p>{{ List[0].phone }}</p>
                <p>{{ List[0].tel }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="phone_foot_phone_div">
          <img src="../../static/img/phonebg.png" />
          <div class="Medium foot-phone">
            <p>{{ List[0].phone }}</p>
            <p>{{ List[0].tel }}</p>
          </div>
        </div>
        <!-- <p class="copyright">Copyright<span style="font-family:Arial;">©</span> 2015快子集团 浙ICP备15057000号</p> -->
        <div class="MediaTest">
          <a href="https://beian.miit.gov.cn/">浙ICP备18032037号-1</a>
          <p>版权所有 © 2018 浙江集壹实业有限公司 保留一切权利</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeBanner from "../components/HomeBanner.vue";
export default {
  components: {
    HomeBanner,
  },
  name: "App",
  data() {
    return {
      navCloseLogo: "../../static/img/nav_close.png",
      isOpenSlider: false,
      downnavshow: false,
      brandshow: false,
      videoshow: false,
      productshow: false,
      jumpList: [
        {
          img: "",
          title: "",
          url: "",
        },
      ],
      List: [
        {
          phone: "",
          tel: "",
          address: "",
          email: "",
        },
      ],
      fouce: true,
      LogoImg: "",
      WxGZHImg: "",
      mainurl: "",
      input: "",
      footer: [],
      activeIndex: "1",
      // clientWight: "",
    };
  },
  mounted() {
    this.getSimple();
    this.getJump();
    this.showActive();
    let that = this;
    $(document).ready(function () {
      $(".nav_father").hover(
        function () {},
        function () {
          console.log("FFFFFF");
          that.resetShow();
        }
      ),
        $(".nav_home").hover(
          function () {
            that.resetShow();
          },
          function () {
            console.log("FFFFFF");
          }
        ),
        $(".nav_callus").hover(
          function () {
            that.resetShow();
          },
          function () {
            console.log("FFFFFF");
          }
        ),
        $(".nav_brand a").hover(
          function () {
            console.log("SSSSS");
            that.showDownNav("Brand");
          },
          function () {
            // console.log("WWWWW");
            // that.downnavshow=false;
          }
        ),
        $(".nav_product a").hover(
          function () {
            console.log("XXXXX");
            that.showDownNav("Products");
          },
          function () {
            // console.log("WWWWW");
            // that.downnavshow=false;
          }
        ),
        $(".nav_download a").hover(
          function () {
            console.log("HHHHH");
            that.showDownNav("Download");
          },
          function () {
            // console.log("WWWWW");
            // that.downnavshow=false;
          }
        );
    });
  },
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
    showDownNav(id) {
      this.downnavshow = true;
      this.productshow = false;
      this.brandshow = false;
      this.videoshow = false;
      if (id === "Brand") {
        this.brandshow = true;
      } else if (id === "Products") {
        this.productshow = true;
      } else if (id === "Download") {
        this.videoshow = true;
      }
    },
    resetShow() {
      this.downnavshow = false;
      this.productshow = false;
      this.brandshow = false;
      this.videoshow = false;
      this.closeSilder();
    },
    scrollNavto(path, name) {
      console.log(path);
      this.resetShow();
      $(".nav_home a").removeClass("active");
      $(".nav_brand a").removeClass("active");
      $(".nav_product a").removeClass("active");
      $(".nav_download a").removeClass("active");
      $(".nav_callus a").removeClass("active");
      // this.showActive();
      if (path === "/Brand") {
        $(".nav_brand a").addClass("active");
      } else if (path === "/Products") {
        $(".nav_product a").addClass("active");
      } else if (path === "/Download") {
        $(".nav_download a").addClass("active");
      }
      this.$router.push({
        path: `${path}`,
        query: { param: name },
      });
    },
    navto(path) {
      this.resetShow();
      this.showActive();
      this.$router.push(path);
    },
    getSimple() {
      let that = this;
      this.$axios
        .get("app/callus/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.List = response.data.page.list;
            console.log(that.List);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getJump() {
      let that = this;
      this.$axios
        .get("app/jumppager/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.jumpList = response.data.page.list;
            // console.log(that.jumpList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    showActive() {
      $("#ul_header li a").click(function (e) {
        $("#ul_header li a").removeClass("active");
        $(this).addClass("active");
      });
    },
    openSilder() {
      if (this.isOpenSlider) {
        this.closeSilder();
      } else {
        this.isOpenSlider = true;
        document.getElementById("mySidebar").style.display = "flex";
      }
    },
    closeSilder() {
      this.resetSlider();
      this.isOpenSlider = false;
      document.getElementById("mySidebar").style.display = "none";
    },
    myAboutFunc() {
      var x = document.getElementById("aboutAcc");
      if (x.className.indexOf("w3-show") == -1) {
        this.resetSlider();
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-green";
      } else {
        x.className = x.className.replace(" w3-show", "");
        x.previousElementSibling.className = x.previousElementSibling.className.replace(
          " w3-green",
          ""
        );
      }
    },
    myProductFunc() {
      var x = document.getElementById("productAcc");
      if (x.className.indexOf("w3-show") == -1) {
        this.resetSlider();
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-green";
      } else {
        x.className = x.className.replace(" w3-show", "");
        x.previousElementSibling.className = x.previousElementSibling.className.replace(
          " w3-green",
          ""
        );
      }
    },
    myVideoFunc() {
      var x = document.getElementById("videoAcc");
      if (x.className.indexOf("w3-show") == -1) {
        this.resetSlider();
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-green";
      } else {
        x.className = x.className.replace(" w3-show", "");
        x.previousElementSibling.className = x.previousElementSibling.className.replace(
          " w3-green",
          ""
        );
      }
    },
    resetSlider() {
      var x1 = document.getElementById("videoAcc");
      var x2 = document.getElementById("productAcc");
      var x3 = document.getElementById("aboutAcc");

      x1.className = x1.className.replace(" w3-show", "");
      x1.previousElementSibling.className = x1.previousElementSibling.className.replace(
        " w3-green",
        ""
      );

      x2.className = x2.className.replace(" w3-show", "");
      x2.previousElementSibling.className = x2.previousElementSibling.className.replace(
        " w3-green",
        ""
      );

      x3.className = x3.className.replace(" w3-show", "");
      x3.previousElementSibling.className = x3.previousElementSibling.className.replace(
        " w3-green",
        ""
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.nav_father {
  display: block;
  width: 168rem;
  height: 8rem;
  margin: 5rem auto 0;
  right: 0;
  left: 0;
  z-index: 1030;
  position: fixed;
}

.nav_down {
  width: 100%;
  height: 12rem;
  margin-top: 8rem;
  background: var(--textBlueColor60);
  display: flex;
  justify-items: center;
  align-items: center;

  .nav_down_brand {
    cursor: pointer;
    margin-left: 42%;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .nav_down_product {
    cursor: pointer;
    margin-left: 36%;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .nav_down_video {
    cursor: pointer;
    margin-left: 53%;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  div {
    margin: 0 4rem;
  }

  img {
    width: 4rem;
    height: 4rem;
    object-fit: contain;
  }

  p {
    color: white;
    font-size: 1.6rem;
    font-family: regular;
    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.4);
  }
}

.nav_down_img {
  transition: all 0.4s;
  // p{
  // margin-top:1rem;
  // }
}

.nav_down_img_margin {
  img {
    margin-bottom: 1rem;
  }
}

.nav_down_img:hover {
  transform: translateY(-0.5rem);
  transition: all 0.4s;
}

.phone_nav {
  display: none;
}

.phone_my_nav {
  height: 60px;
  align-items: center;
  background: white;
  display: flex;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1030;
  justify-content: space-between;

  .phone_logo {
    margin-left: 2rem;
    width: 16rem;
    height: auto;
  }

  .phone_mune_div {
    position: relative;
    width: 3rem;
    height: 100%;
    margin-right: 2rem;
  }

  .phone_mune_logo {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 100%;
    height: auto;
  }
}

.siderbar_close {
  width: 30%;
}

.siderbar_div {
  width: 70%;
  background: var(--textBlueColor60);
}

.w3-sidebar {
  display: flex;
  width: 100%;
  height: 100%;
  right: 0;
  margin-top: 60px;
  z-index: 10;
  background: transparent;
}

.w3-white {
  background-color: transparent !important;
}

.w3-green, .w3-hover-green:hover {
  background-color: var(--textBlueColor80) !important;
}

.fa {
  margin-left: 4rem;
}

.w3-item1 {
  background: transparent;
  padding: 2rem 2rem;
  font-size: 2rem;
  font-family: 'light';
  color: white;
  text-align: center !important;
  border: 1px solid var(--textWhiteColor20);
}

.w3-item2 {
  background: var(--textBlueColor80);
  padding: 2rem 2rem;
  font-size: 1.8rem;
  font-family: 'light';
  color: white;
  text-align: center !important;
  border: 1px solid var(--textWhiteColor20);
}

.w3-button:hover {
  text-decoration: none;
  color: white !important;
  background: var(--textBlueColor80) !important;
}

.my_nav {
  height: 100%;
  align-items: center;
  background: white;
  display: flex;
  width: 100%;
  position: absolute;
  z-index: 1030;

  img {
    margin-left: 5rem;
    width: 24.3rem;
    height: 3.3rem;
  }

  ul {
    list-style-type: none;
    margin: auto;
    padding: 0;
    overflow: hidden;
    background: white;
  }

  li {
    float: left;
    margin: 0 1rem;
  }
}

.navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover {
  background-color: red;
  color: #fff;
}

.flex-container {
  display: flex;
  align-items: center;
}

.flex-container > div {
  padding: 0 2rem 0 0;
}

.foot_msg_row {
  margin: 2rem auto;
  width: 90%;
}

.el-col:first-child {
  padding: 0;
}

.elcol {
  padding: 1rem !important;
}

.foot {
  // background-color: #595757;
  background-image: url('../../static/img/Backg.png');
  background-repeat: no-repeat;
  background-size: cover;
  color: #FFFFFF;
  margin: 0;
  width: 100%;
  font-size: 1.3rem;
  line-height: 2;
}

.Medium_title {
  text-align: left;
  font-size: 1.8rem;
}

.Medium {
  text-align: left;
  font-family: light;
  font-size: 1.7rem;
  color: var(--textWhiteColor50);
}

.MediumClick {
  cursor: pointer;
}

.MediaTest {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 0.1rem solid var(--textWhiteColor50);
  margin: 0;
  padding: 1rem 0;
  text-align: right;
  color: var(--textWhiteColor50);
}

.MediaTest span.active {
  visibility: hidden;
}

.foot-head {
  color: #888888;
  margin: 1rem 0;
}

.foot .foot-text+.foot-text {
  margin-left: 12rem;
}

.el-submenu__icon-arrow {
  position: unset;
}

.foot-logo {
  vertical-align: middle;
}

.foot-icon {
  width: 4.5rem;
}

.copyright {
  border-top: 0.1rem solid #444444;
  padding-top: 1rem;
}

.foot-body {
  cursor: pointer;
}

.foot_phone_div {
  position: relative;

  div {
    position: absolute;
    bottom: 10%;
    left: 0;
    right: 0;
    margin: 0;

    p {
      text-align: center;
    }
  }
}

.phone_foot_phone_div {
  display: none;
}

.foot-phone {
  line-height: 2.2rem;
  font-size: 2.2rem;
  font-family: medium;
  color: white;

  p {
    padding: 0.5rem;
  }
}

.navbar-default {
  background-image: none;
  background-color: #ffffff;
  box-shadow: none;
}

.navbar-brand, .navbar-nav>li>a {
  text-shadow: none;
  height: 5rem;
}

// .container {
// padding: 1rem 0;
// }
.my_navbar_container {
  padding: 0;
  // width:auto;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  justify-content: center;
}

.navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {
  margin-left: 0 !important;
}

.container>.navbar-header {
  // margin-left: 15%;
  // left:3rem;
  // position:absolute;
}

.navbar-fixed-top {
  border-width: 0;
  width: 80%;
  margin: auto;
  margin-top: 3rem;
}

.navbar-brand {
  padding: 1rem 0;

  img {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    margin: auto;
    padding: 0;
    height: 100%;
  }
}

.nav_right_img {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 5rem;
  padding: 0;
  text-align: center;
  font-size: 1.5rem;

  img {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    width: 5rem;
    margin: auto 1rem;
  }
}

.nav_ul {
  background-color: #fff;
  margin: 0 0 0 3rem;

  .nav_end_li a {
    height: 8rem;
    line-height: 8rem;
    padding: 0 0 0 1.5rem;
    font-size: 2.4rem;
    color: #000;
    font-family: bold;
  }

  .nav_li a {
    cursor: pointer;
    margin: 0 1rem 0 0;
    min-width: 10rem;
    height: 8rem;
    line-height: 8rem;
    padding: 0 1.5rem;
    color: #000;
    font-size: 1.8rem;
    font-family: light;
  }

  .nav_li a:hover:not(.active) {
    // background-color: #ec8938;
    color: var(--textBlueColor);
    border-bottom: 3px solid var(--textBlueColor);
  }

  .active {
    // background-color: #ec8938;
    color: var(--textBlueColor) !important;
    border-bottom: 3px solid var(--textBlueColor);
  }
}

@media (max-width: 1500px) {
  .container {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-fixed-top {
    padding: 0 1.5rem;
    width: 80% !important;
  }

  .nav_right_img {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 2rem;
    padding: 0;
    text-align: center;
    font-size: 1.5rem;

    img {
      width: 3rem;
      margin: 0 1rem;
    }
  }

  .foot-icon {
    width: 3rem;
  }

  .foot-phone {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
}

@media (max-width: 1000px) {
  .container {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }

  .navbar-fixed-top {
    padding: 0 1.5rem;
    width: 100% !important;
  }

  .navbar-toggle {
    grid-float-breakpoint: 1000px;
  }

  .navbar-brand {
    height: 5rem;

    img {
      margin: auto;
      padding: 0;
      height: 3rem;
    }
  }

  .my_navbar_container {
    padding: 0;
    width: auto;
    display: block;
  }

  .nav_ul {
    background-color: #fff;

    .nav_li a {
      width: 100%;
      height: 5rem !important;
      line-height: 3rem !important;
      padding: 1rem 1rem !important;
      font-size: 1.4rem;
    }

    .nav_end_li a {
      height: 5rem;
      line-height: 5rem;
      padding: 0 1.5rem;
      font-size: 2rem;
    }
  }
}

@media (max-width: 850px) {
  .foot {
    font-size: 1.4rem;
  }

  .float-right {
    margin-top: 2rem;
  }

  // .nav_right_img{
  // margin-left:0 !important;
  // }
  .nav_ul {
    // background-color: #fff;
    margin: 0;

    .nav_li a {
      // width: 100%;
      // height: 5rem !important;
      // line-height: 3rem !important;
      padding: 1rem 1rem !important;
      font-size: 1.2rem;
    }

    .nav_end_li a {
      // height: 5rem;
      // line-height: 5rem;
      // padding: 0 1.5rem;
      font-size: 1.5rem;
    }
  }

  .navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {
    margin-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  // .navbar-default {
  // width: 100%;
  // }

  // .visible-xs {
  // display: none;
  // }

  // .menu-btn {
  // float: right;
  // }

  // .menu-btn button {
  // float: right;
  // }
  .foot {
    margin-top: 0;
  }
}

@media (min-width: 1800px) {
  .foot {
    font-size: 1.4rem;
    line-height: 2;
  }

  .foot-icon {
    width: 4.5rem;
  }

  .MediaTest {
    padding: 1rem 0 0 0;
  }
}

@media (max-width: 1200px) {
  .my_navbar_container {
    width: 100%;
  }

  .phone_nav {
    display: block;
  }

  .MediaTest {
    padding: 0 1rem;
    flex-direction: column;
    text-align: left;
  }

  .footgone {
    display: none;
  }

  .phone_foot_phone_div {
    display: block;
    position: relative;
    margin: 1rem;

    div {
      position: absolute;
      bottom: 13%;
      left: 0;
      right: 0;
      margin: 0;

      p {
        text-align: center;
      }
    }
  }

  .nav_father {
    display: none;
  }
}

@media (max-width: 800px) {
  .container {
    width: 100% !important;
    padding: 0;
  }

  .foot_msg_row {
    width: 100%;
  }

  .nav_right_img {
    img {
      width: 3rem;
    }
  }
}
</style>
